import { DataServiceModule } from 'services/data/data.service';
import { AppSettingsModule } from 'services/settings.provider';

export const GridServiceModule = angular
    .module('app.components.grid.gridService', [
        AppSettingsModule,
        DataServiceModule
    ]).factory('gridService', ($q, dataService, settings) => {
        return {
            getItems: getItems,
            copy: copy,
            copyAll: copyAll,
            remove: remove,
            removeAll: removeAll,
            getDefaultOptions: getDefaultOptions,
            updateGridCallbacks: updateGridCallbacks
        };

        function getItems(endpoint, page, count, sort, filter, additionalParams = {}) {
            let options;
            page = page || 1;
            count = count || 25;

            const isRestEndpoint = [
                settings.api.cartsREST
            ].includes(endpoint);

            if (isRestEndpoint) {
                options = {
                    first: count,
                    skip: (page - 1) * count
                };
            } else {
                options = {
                    pageSize: count,
                    startIndex: (page - 1) * count
                };
            }

            Object.assign(options, {
                filter: filter || null,
                ...additionalParams
            });

            if (sort && sort.length) {
                options.sortBy = sort[0].replace(' ', '+');
            }

            return dataService.getAll(endpoint, options);
        }

        function copy(endpoint) {
            return function(item, nameLength) {
                var copyItem = angular.copy(item);
                return dataService.copy(endpoint, copyItem, nameLength);
            };
        }

        function copyAll(endpoint) {
            return function(items, nameLength) {
                var promises = items.map(item => copy(endpoint)(item, nameLength));

                return $q.all(promises);
            };
        }

        function promiseSerial(funcs) {
            return funcs.reduce((result, value) => {
                return result.then(response => value().then(Array.prototype.concat.bind(response)));
            }, $q.resolve([]));
        }

        function remove(endpoint, item) {
            return dataService.remove(endpoint, item.id);
        }

        function removeAll(endpoint, items) {
            var functions = [];
            for (let i = 0; i < items.length; i += 1) {
                functions.push(() => dataService.remove(endpoint, items[i].id));
            }
            return promiseSerial(functions);
        }

        function getDefaultOptions(endpoint, onDataResponse, filter) {
            var gridOptions = {
                isLoading: false,
                onLoad: () => {},

                paging: {
                    pageSize: 25,
                    pageSizeOptions: [10, 25, 50, 100],
                    onPageChange: null
                },
                sorting: {
                    onSortChange: null
                }
            };

            updateGridCallbacks(endpoint, filter, gridOptions, onDataResponse);

            return gridOptions;
        }

        function updateGridCallbacks(endpoint, filter, gridOptions, onDataResponse) {
            var pageChange = createChangeCallback(endpoint, onDataResponse, filter, gridOptions, 'page');
            var sortChange = createChangeCallback(endpoint, onDataResponse, filter, gridOptions, 'sort');

            gridOptions.paging.onPageChange = pageChange;
            gridOptions.sorting.onSortChange = sortChange;
        }

        function createChangeCallback(endpoint, callback, filter, gridOptions, changeType) {
            return function(page, count, sort) {
                var options;
                page = page || 1;
                count = count || 25;

                if (gridOptions && changeType !== 'page') {
                    gridOptions.isLoading = true;
                }

                options = {
                    pageSize: this.pageSize || count,
                    startIndex: (page - 1) * count,
                    filter: filter || null
                };

                if (sort && sort.length) {
                    options.sortBy = sort[0].replace(' ', '+');
                }

                dataService.getAll(endpoint, options).then((data) => {
                    callback(data, changeType);
                });
            };
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/grid/grid.service.js